import React, {useContext, useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';

import {AppContext} from '../../../../../AppModule/Context';

import MultiStateButton from '../multiStateButton/multiStateButton';
import ToolTipComponent from '../../toolTipComponent';

import VIDABOO_CONSTANTS from '../../../../../config/consts';
import utilsService from '../../../../../services/utilsService';
import UpgradeIcon from '../../../../../assets/svgComponents/LeftNavigationIcons/UpgradeIcon';

import './upgradeComponent.css';

const UpgradeComponent = ({
  history = {},
  billingPlanFeature = null,
  onUpgrade = null,
  isCrown = false,
}) => {
  const context = useContext(AppContext);
  const [showToolTip, setShowToolTip] = useState(false);

  const [isInTrial, setIsInTrial] = useState(true);
  const [isUpgradeNeeded, setIsUpgradeNeeded] = useState(true);
  const [startingPlan, setStartingPlan] = useState(null);

  useEffect(() => {
    if (billingPlanFeature?.name) {
      const planEnabledFeatures =
        context.billingPlanDto.planEnabledFeatures || [];
      let extraFeatures = context.getCurrentUser().extras;
      if (context.getAccountDto() && context.getAccountDto().isActive) {
        extraFeatures = context.getAccountDto().extras;
      }
      const startingPlan =
        VIDABOO_CONSTANTS.BILLING_PLAN_FEATURES[billingPlanFeature.name]
          ?.startingPlan;
      const upgradeNeeded = !(
        planEnabledFeatures[billingPlanFeature.name] > 0 ||
        (extraFeatures && extraFeatures[billingPlanFeature.name] > 0)
      ); // feature is enabled by plan
      const inTrial = false; //      context.billingPlanDto.name === 'trial';
      // console.debug(context.billingPlanDto.planEnabledFeatures);
      setStartingPlan(startingPlan);
      setIsUpgradeNeeded(upgradeNeeded);
      setIsInTrial(inTrial);
    }
  }, [context.billingPlanDto.planEnabledFeatures, context.getAccountDto()]);

  const handleUpgrade = () => {
    const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
      context.isImpersonatedModeActive,
    );
    history.push(ROUTES.EXPERT_SETTINGS, {
      navUrl: 'accountSettings/billing/billingMyPlan',
      planName: VIDABOO_CONSTANTS.BILLING_PLANS[startingPlan].toLowerCase(),
    });
  };
  const handleToolTip = () => {
    setShowToolTip(!showToolTip);
  };

  return !billingPlanFeature
    ? null
    : !isInTrial && isUpgradeNeeded && (
        <>
          {isCrown ? (
            <div
              className="et-v2-upgrade-crown-container"
              onMouseEnter={handleToolTip}
              onMouseLeave={handleToolTip}>
              <div className="et-v2-upgrade-crown-icon-wrap">
                <UpgradeIcon />
              </div>
              {showToolTip && (
                <ToolTipComponent
                  toolTipPosition={'right'}
                  toolTipTxt={
                    'Step up to ' +
                    startingPlan +
                    ' and access exclusive features! '
                  }
                />
              )}
            </div>
          ) : (
            <div className="et-v2-upgrade-component-container">
              <div className="et-v2-upgrade-component-btn">
                <MultiStateButton
                  isPrimaryBtn
                  btnTxt={'Upgrade to ' + startingPlan}
                  onClick={onUpgrade ? onUpgrade : handleUpgrade}
                />
              </div>
            </div>
          )}
        </>
      );
};

export default withRouter(UpgradeComponent);
